import request from "./request";

const QuizMCQExamService = {
    GetAll: async (id, context, signal) => {
        return await request.sendRequest(`/quizmcqexam/all/${id}`, context.token, signal);
    },
    Start: async (id, context) => {
        return await request.sendPutRequest(`/quizmcqexam/start/${id}`, context);
    },
    GetAttendees: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/quizmcqexam/attendees/-1/0/${id}/${searchText}`, context.token, signal);
    },
    CalculateScore: async (id, context) => {
        return await request.sendPutRequest(`/quizmcqexam/calculate/${id}`, context);
    },
    RecalculateScore: async (id, context) => {
        return await request.sendPutRequest(`/quizmcqexam/re-calculate/${id}`, context);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/quizmcqexam`, payload, context, signal);
    },
    RemoveSession: async (quizId, userId, context) => {
        return await request.sendDeleteRequest(`/quizmcqexam/session/${quizId}/${userId}`, context.token);
    },
};

export default QuizMCQExamService;
